// initial state
const state = {
    open: false,
    message: '',
    color: 'info',
    timer: null,
    paymentAuditLinkVisible: false,
    defaultCloseTime: 5000
}

// getters
const getters = {
    
}

// actions
const actions = {
    showMessage(context, payload) {
        context.commit('clearTimer');
        context.commit('updateMessage', payload);
        const timer = setTimeout(() => {
            context.commit('updateOpen', false);
        }, payload.timeout || context.state.defaultCloseTime);
        context.commit('updateTimer', timer);
    },
    hideMessage(context) {
        context.commit('updateOpen', false);
    }
}

// mutations
const mutations = {
    updateMessage(state, payload) {
        state.message = payload.message;
        state.color = payload.color;
        state.paymentAuditLinkVisible = payload.paymentAuditLinkVisible || false
        state.open = true;
    },
    updateOpen(state, open) {
        state.open = open;
    },
    updateTimer(state, timer) {
        state.timer = timer;
    },
    clearTimer(state) {
        if (state.timer) {
            clearTimeout(state.timer);
        }
    }
}
  
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/notify.js